export interface Role {
    role_id: string;
    role_name: string;
    description: string;
    hierarchy_level: number;
}

export const RoleTypes = {
    ADMINISTRATOR: 'administrator',
    HELPDESK: 'helpdesk',
    MANAGER: 'manager',
    AGENT: 'agent',
    CLIENT_ADMINISTRATOR: 'client_administrator',
    CLIENT_MANAGER: 'client_manager',
    CLIENT_EMPLOYEE: 'client_employee',
    SUPERVISOR: 'supervisor'
} as const;

export type UserRole = typeof RoleTypes[keyof typeof RoleTypes];

export const RoleNames: Record<keyof typeof RoleTypes, string> = {
    ADMINISTRATOR: 'Administrator',
    HELPDESK: 'Ticket Admin.',
    MANAGER: 'Manager',
    AGENT: 'Agent',
    CLIENT_ADMINISTRATOR: 'Διαχειριστής',
    CLIENT_MANAGER: 'Προϊστάμενος',
    CLIENT_EMPLOYEE: 'Εκπρόσωπος',
    SUPERVISOR: 'Επιβλέπων'
};

export const ROLE_NAME_TO_TYPE: Record<string, UserRole> = {
    'Administrator': RoleTypes.ADMINISTRATOR,
    'Ticket Admin.': RoleTypes.HELPDESK,
    'Manager': RoleTypes.MANAGER,
    'Agent': RoleTypes.AGENT,
    'Διαχειριστής': RoleTypes.CLIENT_ADMINISTRATOR,
    'Προϊστάμενος': RoleTypes.CLIENT_MANAGER,
    'Εκπρόσωπος': RoleTypes.CLIENT_EMPLOYEE,
    'Επιβλέπων': RoleTypes.SUPERVISOR
};


// Keep only the role-related functionality here
const CLIENT_ROLES = [
    RoleTypes.CLIENT_ADMINISTRATOR,
    RoleTypes.CLIENT_MANAGER,
    RoleTypes.CLIENT_EMPLOYEE
] as const;

const ADMIN_ROLES = [
    RoleTypes.ADMINISTRATOR,
    RoleTypes.HELPDESK,
] as const;

export const isClientRole = (role: UserRole): boolean => {
    return CLIENT_ROLES.includes(role as never);
};

export const isAdminRole = (role: UserRole): boolean => {
    return ADMIN_ROLES.includes(role as never);
};
